/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import { withTranslation } from 'react-i18next';
import Loader from '../../../Common/Loader';
const ArticleCard = ({ t, index, destUrl, heading, contentType }) => {
  return (
    <div className="articleCard iframeSwipe">
      <span className="screenreader" id={`iframeAccess${index}`}>
        {contentType} {heading}
      </span>
      <a
        className="hasLimitedAccess"
        aria-describedby={`iframeAccess${index}`}
        href={destUrl}
        target="_blank"
        aria-label={
          t('articleIframeText')
            ? t('articleIframeText')
            : 'To read this article in full, press enter to open in a new browser'
        }
        tabIndex="0"
        rel="noopener noreferrer"
        style={{ transform: 'scale(0)' }}
      ></a>
      <iframe
        scrolling="yes"
        className="iframedom"
        src=""
        data-pageurl={destUrl}
        border="0"
        height="100%"
        width="100%"
        title="articlepage"
        aria-hidden="true"
        tabIndex="-1"
      ></iframe>
      <Loader className="iframeloader" ariaHidden="true" tabIndex="-1" />
    </div>
  );
};
export default withTranslation()(ArticleCard);
